// extracted by mini-css-extract-plugin
export default {"TemperatureField":"styles_TemperatureField__Qw4cF"};